import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { FormattedTime, FormattedMessage } from "react-intl";
import Message from "./Message";
import SystemMessage from "./SystemMessage";
import UserActivityMessage from "./UserActivityMessage";
import { Button } from "@material-ui/core";

const styles = (theme) => ({
  root: {
    overflowY: "auto",
    padding: theme.spacing(1),
    height: "95%",
  },
  loadMoreButton: {
    height: "auto",
    marginBottom: theme.spacing(2),
    "&:hover": {
      backgroundColor: "rgba(50,137,239,0.11)",
    },
  },
});

class MessageList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { messageCountToShow: 10, messageCountToShowPrivate: 10 };
  }
  componentDidMount() {
    this.node.scrollTop = this.node.scrollHeight;
  }

  //TODO getSnapshotBeforeUpdate is now present for hooks for now. This component will be refactored to functional component and will use hooks when it is possible
  getSnapshotBeforeUpdate() {
    return (
      this.node.scrollTop + this.node.offsetHeight === this.node.scrollHeight
    );
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.privateChatMessages !== this.props.privateChatMessages)
      return true;
    if (nextProps.chat.length !== this.props.chat.length) return true;
    if (nextState.messageCountToShow !== this.state.messageCountToShow)
      return true;
    if (
      nextState.messageCountToShowPrivate !==
      this.state.messageCountToShowPrivate
    )
      return true;
    if (nextProps.selectedPeer !== this.props.selectedPeer) {
      this.setState({ messageCountToShowPrivate: 10, messageCountToShow: 10 });
      return true;
    }
    return false;
  }

  componentDidUpdate(prevProps, prevState, shouldScroll) {
    this.node.scrollTop = this.node.scrollHeight;
    if (prevState.messageCountToShow !== this.state.messageCountToShow)
      this.node.scrollTo(0, 0);
    if (
      prevState.messageCountToShowPrivate !==
      this.state.messageCountToShowPrivate
    )
      this.node.scrollTo(0, 0);
  }

  getTimeString(time) {
    return <FormattedTime value={new Date(time)} />;
  }

  render() {
    const {
      chat,
      myPicture,
      classes,
      myId,
      privateChatMessages,
      selectedPeer,
      currentToolTab,
    } = this.props;

    var messages = [];
    if (privateChatMessages) {
      messages = [];
      messages = privateChatMessages.slice(
        Math.max(
          privateChatMessages.length - this.state.messageCountToShowPrivate,
          0
        )
      );
    } else if (!privateChatMessages && selectedPeer.id) messages = [];
    else {
      messages = [];
      messages = chat.slice(
        Math.max(chat.length - this.state.messageCountToShow, 0)
      );
    }

    const handleLoadMore = () => {
      this.setState({ messageCountToShow: this.state.messageCountToShow + 20 });
    };
    const handleLoadMorePrivate = () => {
      this.setState({
        messageCountToShowPrivate: this.state.messageCountToShowPrivate + 20,
      });
    };

    const handleButton = () => {
      if (
        currentToolTab === "privateChat" &&
        privateChatMessages &&
        privateChatMessages.length > 10
      ) {
        return (
          <Button
            variant="text"
            size="small"
            onClick={handleLoadMorePrivate}
            className={classes.loadMoreButton}
          >
            <FormattedMessage
              id="tooltip.loadMore"
              defaultMessage="Load More"
            />
          </Button>
        );
      } else if (
        currentToolTab === "privateChat" &&
        privateChatMessages === undefined
      )
        return;
      else if (currentToolTab === "chat" && chat.length > 10) {
        return (
          <Button
            variant="text"
            size="small"
            onClick={handleLoadMore}
            className={classes.loadMoreButton}
          >
            <FormattedMessage
              id="tooltip.loadMore"
              defaultMessage="Load More"
            />
          </Button>
        );
      } else return;
    };

    return (
      <div
        style={{ marginBottom: "11%" }}
        className={classes.root}
        ref={(node) => {
          this.node = node;
        }}
      >
        {handleButton()}
        {messages.map((message, index) => {
          if (message.sender === "SYSTEM") {
            if (message.type === "USER_ACTIVITY") {
              return (
                <UserActivityMessage
                  key={index}
                  text={message.text}
                  time={this.getTimeString(message.time)}
                  name={message.name}
                />
              );
            } else {
              return (
                <SystemMessage
                  key={index}
                  text={message.text}
                  time={this.getTimeString(message.time)}
                  name={message.name}
                />
              );
            }
          } else {
            const picture =
              message.sender === "response" ? message.picture : myPicture;
            return (
              <Message
                key={index}
                self={message.senderId === myId}
                picture={picture}
                text={message.text}
                time={this.getTimeString(message.time)}
                name={message.name}
                peerId={message.senderId}
              />
            );
          }
        })}
      </div>
    );
  }
}

MessageList.propTypes = {
  chat: PropTypes.array,
  myPicture: PropTypes.string,
  selectedPeer: PropTypes.object,
  privateChatMessages: PropTypes.array,
  classes: PropTypes.object.isRequired,
  selectedPeer: PropTypes.object,
  currentToolTab: PropTypes.string,
};

const mapStateToProps = (state) => ({
  chat: state.chat,
  myPicture: state.me.picture,
  myId: state.me.id,
});

export default connect(mapStateToProps, null, null, {
  areStatesEqual: (next, prev) => {
    return (
      prev.chat === next.chat &&
      prev.me.picture === next.me.picture &&
      prev.me.id === next.me.id
    );
  },
})(withStyles(styles)(MessageList));
